import { render } from "./ManualVerificationHistoryView.vue?vue&type=template&id=fa97c184&scoped=true"
import script from "./manual_verification_history_view.js?vue&type=script&lang=js&external"
export * from "./manual_verification_history_view.js?vue&type=script&lang=js&external"

import "../../../views/onboarding_system_views/Gates/Verification/manage_verification.css?vue&type=style&index=0&id=fa97c184&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa97c184"]])

export default __exports__